export const ForcedTabIdKey = 'forcedTabId';
export const TabIdKey = 'tabId';
